import toastHelper from "../../Util/toastHelper";

import { createAsyncThunk } from "@reduxjs/toolkit";
import API from "../../API/API";
import axios from "axios";

export const getAllCoupons = createAsyncThunk(
  "coupon/getAllCoupons",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getAllCoupons.url,
        method: API.admin.getAllCoupons.method,
      });
      return data?.vouchers;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const addCoupon = createAsyncThunk(
  "coupon/addCoupon",
  async (
    params: {
      name: string;
      percent: number;
      maxDiscount: number;
      startDate: string;
      endDate: string;
      voucherType: number;
      voucherLimit: number;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.addCoupon.url,
        method: API.admin.addCoupon.method,
        data: params,
      });
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const updateCouponById = createAsyncThunk(
  "coupon/updateCouponById",
  async (
    params: {
      id: string;
      name: string;
      percent: number;
      maxDiscount: number;
      startDate: string;
      endDate: string;
      voucherType: number;
      voucherLimit: number;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.updateCouponById.url,
        method: API.admin.updateCouponById.method,
        data: params,
      });
      params.successHandler();
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const getCouponById = createAsyncThunk(
  "coupon/getCouponById",
  async (params: { id: string }, { rejectWithValue }) => {
    try {
      const { data } = await axios({
        url: API.admin.getCouponById.url + params.id,
        method: API.admin.getCouponById.method,
      });
      return data?.voucher;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);

export const inactiveCoupon = createAsyncThunk(
  "coupon/inactiveCoupon",
  async (
    params: {
      id: string;
      successHandler: () => void;
    },
    { rejectWithValue },
  ) => {
    try {
      const { data } = await axios({
        url: API.admin.inactiveCoupon.url + params.id,
        method: API.admin.inactiveCoupon.method,
      });
      params.successHandler();
      toastHelper.success(data?.message);
      return data;
    } catch (error: any) {
      if (error?.response?.data?.message) {
        toastHelper.error(error?.response?.data?.message);
      } else {
        toastHelper.error("Something went wrong");
      }
      return rejectWithValue(JSON.stringify(error));
    }
  },
);
